'use client';

import Icon from '@/components/icon/Icon';
import LinkNavigationItem from '@/components/linkNavigationItem/LinkNavigationItem';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import {Button} from '@/components/ui/button';
import Wysiwyg from '@/components/wysiwyg/Wysiwyg';
import tag from '@/gtm/tag';
import type OnboardingStep from '@/types/OnboardingStep';
import type {PortableTextProps} from '@portabletext/react';

type OnboardingStatusProps = {
  onClick?: () => void;
  profileProgress?: {label: string; completed: boolean}[];
  step: OnboardingStep;
};

export default function OnboardingStatus({onClick, profileProgress, step}: OnboardingStatusProps) {
  const hasProfileProgress = profileProgress && profileProgress.length > 0;

  function handleOnClickCta() {
    tag.interactWithOnboardingCta(step.actionKey);

    onClick?.();
  }

  return (
    <div key={step.key} className="box mb-4 flex flex-col gap-4 p-4">
      <div className="flex items-center gap-2">
        <Icon name={step.icon} size={48} className="text-primary" />
        <h3 className="text-lg font-bold">{step.title}</h3>
      </div>
      <Wysiwyg value={step.description as PortableTextProps['value']} />
      {hasProfileProgress && (
        <Accordion type="single" collapsible>
          <AccordionItem value="Profile Progress" className="border-b-0">
            <AccordionTrigger className="py-0">Profile Progress</AccordionTrigger>
            <AccordionContent>
              <div className="space-y-2 pt-3">
                {profileProgress.map((progress) => (
                  <div key={progress.label} className="flex items-center gap-2">
                    <Icon
                      name={progress.completed ? 'circle-check' : 'circle'}
                      size={22}
                      className={progress.completed ? 'text-primary' : undefined}
                    />
                    <p>{progress.label}</p>
                  </div>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      )}
      <Button asChild onClick={handleOnClickCta} size="sm">
        <LinkNavigationItem data={step.cta} />
      </Button>
    </div>
  );
}
